import * as React from "react";
// Remember that all const are suffix _svg

const isotype_svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
    <circle cx="13" cy="13" r="10" />
  </svg>
);

export { isotype_svg };
